<template>
  <div id="popup_get_resume" :class="$store.state.tariff.style" class="create__new">
    <div class="popup_block">
      <div class="back_to_icon" @click="backPayment()"></div>
      <div class="close" @click="$store.commit('isOpenConfirmModal',false)"></div>
      <div class="title_plane" v-html="$store.getters.t('there__are__cv')"></div>
      <div class="buttons--center">
        <button @click="createCvPage" class="btn-ok">{{$store.getters.t('new__cv')}}</button>
        <button @click="goToProfile" class="btn-ok">{{ $store.getters.t('go__cvs')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ConfirmModal",
    methods:{
      goToProfile(){
        this.$store.commit('isOpenConfirmModal',false);
        this.$router.push({
          name: "profile",
          params: {lang: this.$store.getters.locale}
        });
      },
      createCvPage(){
        const version = this.$store.getters.isOpenConfirmModal.version;
        this.$store.commit('isOpenConfirmModal',false);
        this.$router.push({
          name: "cv-create-" + version,
          params: {lang: this.$store.getters.locale}
        });
      },
      backPayment() {
        this.$store.commit('isOpenTariffModel',true);
        this.$store.commit('isOpenConfirmModal',false);
      }
    }
  }
</script>

<style scoped>
  .buttons--center{
    text-align: center;
  }
  .btn-ok{
    margin: 30px auto;
    padding: 0 15px;
    border-radius: 10px;
    font-size: 20px;
    color: #ffffff;
    font-family: "Roboto Regular", Arial;
    height: 42px;
    border: none;
    outline: 0;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    background-image: -webkit-gradient(linear, left top, right top, from(#00e09a), color-stop(50%, #00ceca), to(#00e09a));
    background-image: linear-gradient(to right, #00e09a 0%, #00ceca 50%, #00e09a 100%);
    -moz-background-image: linear-gradient(to right, #00e09a 0%, #00ceca 50%, #00e09a 100%);
    -o-background-image: linear-gradient(to right, #00e09a 0%, #00ceca 50%, #00e09a 100%);
    -webkit-background-image: -webkit-gradient(linear, left top, right top, from(#00e09a), color-stop(50%, #00ceca), to(#00e09a));
    -webkit-background-image: linear-gradient(to right, #00e09a 0%, #00ceca 50%, #00e09a 100%);
    background-size: 200% auto;
    cursor: pointer;
  }
  .btn-ok:hover{
    background-position: right center;
    -moz-background-position: right center;
    -o-background-position: right center;
    -webkit-background-position: right center;
  }
  #popup_get_resume.create__new .popup_block{
    max-width: 480px;
  }
  .title_plane{
    line-height: 35px;
    padding-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/modals/ConfirmModal.vue